import { Box, Card, Slider, styled, Typography } from "@mui/material"

const StyledCard = styled(Card)(() => ({
    borderRadius: '20px',
    background: '#FFFFFF',
    border: '1px solid var(--Light-Gray)',
    padding: '32px',
    boxShadow: '0px 1px 2px 0px #0205111A',
    '&:hover': {
      boxShadow: '0px 1px 2px 0px #0205111A',
    },
  }));

const StyledButton = styled(Box)(() => ({
    padding: '6px 14px',
    borderRadius: '8px',
    background: 'var(--Light-Gray)',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    color: 'var(--Interviewer-Green)',
    display: 'inline-block',
    width: 'fit-content',
}))

const TimeSlider = styled(Slider)({
    height: '8px',
  
    '& .MuiSlider-rail': {
      height: '8px',
      backgroundColor: '#F0F1F3',
      borderRadius: '4px',
    },
  
    '& .MuiSlider-track': {
      height: '8px',
      border: 'none',
      borderRadius: '4px',
      background: 'linear-gradient(90deg, #31C07D 0%, #47C5FB 35%, #9747FF 75%, #EB4335 100%)',
    },
  
    '& .MuiSlider-thumb': {
        height: '20px',
        width: '20px',
        backgroundColor: '#EB4335',
        boxShadow: '0px 2px 4px rgba(0,0,0,0.2)',
        border: 'none',
        position: 'relative',

        '&::before': {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: '#fff',
        },

        '&:hover': {
            boxShadow: '0px 2px 8px rgba(235, 67, 53, 0.4)',
        },
    },
});

interface TimeSelectionCardProps {
  title: string;
  description: string;
  value: number; // value in seconds
  onChange: (value: number) => void;
  max?: number;
  min?: number;
}

const TimeSelectionCard = ({ 
  title, 
  description, 
  value, 
  onChange, 
  max = 300, // 5 minutes in seconds
  min = 0 
}: TimeSelectionCardProps) => {
    const handleChange = (_event: Event, newValue: number | number[]) => {
        onChange(newValue as number);
    };

    const formatTime = (seconds: number) => {
        if (seconds < 60) {
            return `${seconds}s`;
        }
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        if (remainingSeconds === 0) {
            return `${minutes}min`;
        }
        return `${minutes}min ${remainingSeconds}s`;
    };

    const getMarks = () => {
        return [
            { value: 0, label: '0s' },
            { value: 60, label: '1min' },
            { value: 120, label: '2min' },
            { value: 180, label: '3min' },
            { value: 240, label: '4min' },
            { value: 300, label: '5min' }
        ];
    };

    return (
        <StyledCard>
            <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: '16px'}}>
                <Typography variant="h2">{title}</Typography>
                <StyledButton>{formatTime(value)}</StyledButton>
            </Box>
            <Typography sx={{pb: '28px'}}>{description}</Typography>
            <Box sx={{ px: 2 }}>
                <TimeSlider
                    value={value}
                    onChange={handleChange}
                    max={max}
                    min={min}
                    marks={getMarks()}
                    valueLabelDisplay="auto"
                />
            </Box>
        </StyledCard>
    )
}

export default TimeSelectionCard;